import { getTrendIcon } from "../../Common/utils";
import { CtaButton } from "../Buttons";
import TeamSerialNumber from "../TeamSerialNumber";

const LeagueTeamScore = ({
  teamNumber,
  score,
  trend,
  isJoined = true,
  onAddTeam = () => {},
}) => {
  const trendValue = getTrendIcon(trend);
  const trendIcon = trendValue === "f1i-lbd-unchanged" ? null : trendValue;

  return (
    <div
      className={`si-league__teamScore ${
        !isJoined && "si-league__teamScore--notJoined"
      }`}
    >
      <TeamSerialNumber teamNumber={teamNumber} isInactive={!isJoined} />
      {isJoined ? (
        <>
          {score ? (
            <>
              <span className="si-league__teamScore-score">{score}</span>
              <span className="si-league__teamScore-trend">
                {trendIcon && <i className={trendIcon}></i>}
              </span>
            </>
          ) : (
            <span className="si-league__teamScore-score">--</span>
          )}
        </>
      ) : (
        <CtaButton
          variant="ghost"
          icon="f1i-add"
          leadingIcon={true}
          classes="si-league__teamScore-addBtn"
          onClick={(e) => {
            e.stopPropagation();
            onAddTeam();
          }}
        >
          Add
        </CtaButton>
      )}
    </div>
  );
};

export default LeagueTeamScore;
